export default "__VITE_ASSET__BtanrTwn__"